/**
 * FAQService — FAQ submission API wrapper.
 */

const BASE_URL = "https://api.docity.co";

function getAuthHeaders(extra = {}) {
  const token = localStorage.getItem("token");
  return {
    "Content-Type": "application/json",
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...extra,
  };
}

const FAQService = {
  /** Submit a new FAQ / support request. */
  async createFaq(data) {
    try {
      const res = await fetch(`${BASE_URL}/createFaq`, {
        method: "POST",
        headers: getAuthHeaders(),
        body: JSON.stringify(data),
      });
      const json = await res.json();
      return json;
    } catch (err) {
      console.error("FAQService.createFaq:", err);
      return { message: "Error", error: err.message };
    }
  },
  async getFAQS(data) {
    try {
      const res = await fetch(`${BASE_URL}/getFAQS`, {
        method: "GET",
        headers: getAuthHeaders(),
      });
      const json = await res.json();
      return json;
    } catch (err) {
      console.error("FAQService.createFaq:", err);
      return { message: "Error", error: err.message };
    }
  },
  async replyToFAQ(data) {
    try {
      const res = await fetch(`${BASE_URL}/replyToFAQ`, {
        method: "POST",
        headers: getAuthHeaders(),
        body: JSON.stringify(data),
      });
      const json = await res.json();
      return json;
    } catch (err) {
      console.error("FAQService.createFaq:", err);
      return { message: "Error", error: err.message };
    }
  },
};

export default FAQService;
